module.exports = __webpack_public_path__ + "img/des_piano_01.6b436dc0.jpg";